import React from 'react'
import Tooltip from '@mui/material/Tooltip'
import Button from '@mui/material/Button'
import CheckCircleOutlineRounded from '@mui/icons-material/CheckCircleOutlineRounded'
import CloseRounded from '@mui/icons-material/CloseRounded'

type Props = {
  variant: 'apply' | 'clear'
  tooltipProps?: tooltipProps
  disabled?: boolean
  onClick?: React.MouseEventHandler<HTMLButtonElement>
}

type tooltipProps = {
  title: string,
  disableHover?: boolean
}

const attr: Record<string, { title: string, color: "primary" | "warning", icon: React.ReactNode }> = {
  apply: {
    title: 'Aplicar Filtros',
    color: 'primary',
    icon: <CheckCircleOutlineRounded />
  },
  clear: {
    title: 'Limpar Filtros',
    color: 'warning',
    icon: <CloseRounded />
  }
}

const ApplyFilterButton: React.FC<Props> = (props) => {
  return (
    <Tooltip
      title={props.tooltipProps?.title} placement="right" arrow
      disableHoverListener={!props.tooltipProps?.title || props.tooltipProps?.disableHover}
    >
      <span>
        <Button variant="outlined" color={attr[props.variant].color} size="medium" disabled={props.disabled}
          startIcon={attr[props.variant].icon}
          onClick={props.onClick}
        >
          {attr[props.variant].title}
        </Button>
      </span>
    </Tooltip>
  )
}

export default ApplyFilterButton
